import g from "../../../../../@vue_babel-helper-vue-jsx-merge-props@1.4.0/node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.js";
import { noop as u } from "../utils/index.js";
import { BORDER_TOP as B, BORDER_LEFT as p } from "../utils/constant.js";
import { PopupMixin as v } from "../mixins/popup/index.js";
import f from "../button/index.js";
import C from "../goods-action/index.js";
import d from "../goods-action-button/index.js";
import { addUnit as y } from "../utils/format/unit.js";
import { createNamespace as w } from "../utils/create/index.js";
var h = w("dialog"),
  k = h[0],
  o = h[1],
  l = h[2];
var _ = k({
  mixins: [v()],
  props: {
    title: String,
    theme: String,
    width: [Number, String],
    message: String,
    className: null,
    callback: Function,
    beforeClose: Function,
    messageAlign: String,
    cancelButtonText: String,
    cancelButtonColor: String,
    confirmButtonText: String,
    confirmButtonColor: String,
    showCancelButton: Boolean,
    overlay: {
      type: Boolean,
      default: !0
    },
    allowHtml: {
      type: Boolean,
      default: !0
    },
    transition: {
      type: String,
      default: "van-dialog-bounce"
    },
    showConfirmButton: {
      type: Boolean,
      default: !0
    },
    closeOnPopstate: {
      type: Boolean,
      default: !0
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: !1
    }
  },
  data: function data() {
    return {
      loading: {
        confirm: !1,
        cancel: !1
      }
    };
  },
  methods: {
    onClickOverlay: function onClickOverlay() {
      this.handleAction("overlay");
    },
    handleAction: function handleAction(t) {
      var n = this;
      this.$emit(t), this.value && (this.beforeClose ? (this.loading[t] = !0, this.beforeClose(t, function (e) {
        e !== !1 && n.loading[t] && n.onClose(t), n.loading.confirm = !1, n.loading.cancel = !1;
      })) : this.onClose(t));
    },
    onClose: function onClose(t) {
      this.close(), this.callback && this.callback(t);
    },
    onOpened: function onOpened() {
      var t = this;
      this.$emit("opened"), this.$nextTick(function () {
        var n;
        (n = t.$refs.dialog) == null || n.focus();
      });
    },
    onClosed: function onClosed() {
      this.$emit("closed");
    },
    onKeydown: function onKeydown(t) {
      var n = this;
      if (t.key === "Escape" || t.key === "Enter") {
        if (t.target !== this.$refs.dialog) return;
        var e = {
          Enter: this.showConfirmButton ? function () {
            return n.handleAction("confirm");
          } : u,
          Escape: this.showCancelButton ? function () {
            return n.handleAction("cancel");
          } : u
        };
        e[t.key](), this.$emit("keydown", t);
      }
    },
    genRoundButtons: function genRoundButtons() {
      var t = this,
        n = this.$createElement;
      return n(C, {
        class: o("footer")
      }, [this.showCancelButton && n(d, {
        attrs: {
          size: "large",
          type: "warning",
          text: this.cancelButtonText || l("cancel"),
          color: this.cancelButtonColor,
          loading: this.loading.cancel
        },
        class: o("cancel"),
        on: {
          click: function click() {
            t.handleAction("cancel");
          }
        }
      }), this.showConfirmButton && n(d, {
        attrs: {
          size: "large",
          type: "danger",
          text: this.confirmButtonText || l("confirm"),
          color: this.confirmButtonColor,
          loading: this.loading.confirm
        },
        class: o("confirm"),
        on: {
          click: function click() {
            t.handleAction("confirm");
          }
        }
      })]);
    },
    genButtons: function genButtons() {
      var t = this,
        n,
        e = this.$createElement,
        s = this.showCancelButton && this.showConfirmButton;
      return e("div", {
        class: [B, o("footer")]
      }, [this.showCancelButton && e(f, {
        attrs: {
          size: "large",
          loading: this.loading.cancel,
          text: this.cancelButtonText || l("cancel"),
          nativeType: "button"
        },
        class: o("cancel"),
        style: {
          color: this.cancelButtonColor
        },
        on: {
          click: function click() {
            t.handleAction("cancel");
          }
        }
      }), this.showConfirmButton && e(f, {
        attrs: {
          size: "large",
          loading: this.loading.confirm,
          text: this.confirmButtonText || l("confirm"),
          nativeType: "button"
        },
        class: [o("confirm"), (n = {}, n[p] = s, n)],
        style: {
          color: this.confirmButtonColor
        },
        on: {
          click: function click() {
            t.handleAction("confirm");
          }
        }
      })]);
    },
    genContent: function genContent(t, n) {
      var e = this.$createElement;
      if (n) return e("div", {
        class: o("content")
      }, [n]);
      var s = this.message,
        a = this.messageAlign;
      if (s) {
        var r,
          c,
          m = {
            class: o("message", (r = {
              "has-title": t
            }, r[a] = a, r)),
            domProps: (c = {}, c[this.allowHtml ? "innerHTML" : "textContent"] = s, c)
          };
        return e("div", {
          class: o("content", {
            isolated: !t
          })
        }, [e("div", g([{}, m]))]);
      }
    }
  },
  render: function render() {
    var t = arguments[0];
    if (this.shouldRender) {
      var n = this.message,
        e = this.slots(),
        s = this.slots("title") || this.title,
        a = s && t("div", {
          class: o("header", {
            isolated: !n && !e
          })
        }, [s]);
      return t("transition", {
        attrs: {
          name: this.transition
        },
        on: {
          afterEnter: this.onOpened,
          afterLeave: this.onClosed
        }
      }, [t("div", {
        directives: [{
          name: "show",
          value: this.value
        }],
        attrs: {
          role: "dialog",
          "aria-labelledby": this.title || n,
          tabIndex: 0
        },
        class: [o([this.theme]), this.className],
        style: {
          width: y(this.width)
        },
        ref: "dialog",
        on: {
          keydown: this.onKeydown
        }
      }, [a, this.genContent(s, e), this.theme === "round-button" ? this.genRoundButtons() : this.genButtons()])]);
    }
  }
});
export { _ as default };
